<template lang="pug">
  router-view
</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
const groupController = createNamespacedHelpers('group')

export default {
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...groupController.mapState({
      cases: state => state.cases
    })
  },
  methods: {
    ...mapActions(['case/get', 'account/parameters', 'account/userAttributes']),
    getUserAttributes () {
      const self = this

      this['account/userAttributes']({
        account_id: self.$route.params.account_id,
        callback: res => {
          if (res.error) {
            self.$message.error(res.error)
          }
        }
      })
    }    
  },
  async mounted () {
    this.getUserAttributes()

    this.$nextTick(() => {
      this.toggleSidenav('inbox-init', 'close', true)
    })
  },
  beforeUnmount () {

  }
}
</script>
